export default {
  id: null,
  companyID: null,
  areaID: null,
  insuranceID: null,
  name: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/businesstypemodel.js